<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('remplacementFace.filtre.reference')">
            <qd-taginput v-model="critereRecherche.references"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('remplacementFace.filtre.libelle')">
            <qd-taginput v-model="critereRecherche.libelles"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('remplacementFace.filtre.adresses')">
            <qd-taginput v-model="critereRecherche.adresses"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('remplacementFace.filtre.codePostal')">
            <qd-taginput v-model="critereRecherche.codesPostaux"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('remplacementFace.filtre.ville')">
            <ville-tag-input-auto-complete
              :critere-recherche="critereRecherche"
              table-name="Tiers"/>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('remplacementFace.filtre.departement')">
            <qd-taginput v-model="critereRecherche.departements"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('remplacementFace.filtre.agglomeration')">
            <qd-taginput v-model="critereRecherche.agglomerations"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('remplacementFace.filtre.format')">
            <qd-taginput v-model="critereRecherche.formats"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('remplacementFace.filtre.materiel')">
            <qd-taginput v-model="critereRecherche.materiels"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('remplacementFace.filtre.support')">
            <qd-taginput v-model="critereRecherche.supports"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.apply')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('general.button.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import {
  genererCritereRechercheProduitFaceRemplacement,
} from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitFace';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';

export default {
  props: {
    critereRechercheFromPage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      critereRecherche: null,
    };
  },
  components: {
    VilleTagInputAutoComplete,
  },
  methods: {
    viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRechercheProduitFaceRemplacement());
    },
    appliquerCritere() {
      this.$emit('updateCritereAndSearch', this.critereRecherche);
    },
  },
  mounted() {
    this.critereRecherche = cloneDeep(this.critereRechercheFromPage);
  },
};

</script>
